import React from 'react';
import styled from 'styled-components';

const Box = styled.div`
  flex: none;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
`;

export const SelectCheckbox = ({ checked, onToggle, style }) => (
  <Box
    role="button"
    tabIndex={0}
    aria-label="Select file"
    onClick={onToggle}
    onKeyDown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onToggle(event);
      }
    }}
    style={{
      border: `2px solid ${checked ? '#4B5EE6' : '#CDD3DF'}`,
      background: checked ? '#4B5EE6' : '#FFFFFF',
      ...style
    }}
  >
    {checked ? '✓' : ''}
  </Box>
);

export default SelectCheckbox;
